import { navigate } from "../utils/navigation";
import { Exceptionless, ExceptionlessErrorBoundary } from "@exceptionless/react";

export function logInfo(message, source = '') {
    console.info(source ? `${source}: ${message}` : message);

    try {
        Exceptionless.submitLog(source, message, "Log");
    } catch (error) {
        console.error(`Unable to log to EXCEPTIONLESS ${source}:`, error);
    }
}

export function logException(error) {
    const err = error instanceof Error ? error : new Error(String(error?.message ?? error ?? 'Unknown error'));
    console.error(`EXCEPTION: ${err.message}`, err);

    try {
        Exceptionless.submitException(err);
    } catch (loggingError) {
        console.error(`Unable to log exception to EXCEPTIONLESS:`, loggingError);
    }
}

export function logError(errorMessage) { 
    console.error(`${errorMessage}`);

    try {
        Exceptionless.submitLog("", errorMessage, "Error");
    } catch (loggingError) {
        console.error(`Unable to log error to EXCEPTIONLESS:`, loggingError);
    }
}

export function logNotFound(path) {
    try {
        Exceptionless.submitNotFound(path);
    } catch (loggingError) {
        console.error(`Unable to log not found event to EXCEPTIONLESS:`, loggingError);
    }
}